/**
 * 时间工具函数
 * 统一处理时间显示，确保使用北京时间
 */

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/zh-cn';

// 扩展dayjs插件
dayjs.extend(utc);
dayjs.extend(timezone);

// 设置默认时区为北京时间
dayjs.tz.setDefault('Asia/Shanghai');

/**
 * 格式化时间为北京时间
 * @param date 时间字符串或Date对象
 * @param format 格式化模式，默认为 'YYYY-MM-DD HH:mm:ss'
 * @returns 格式化后的北京时间字符串
 */
export const formatBeijingTime = (
  date: string | Date | dayjs.Dayjs,
  format: string = 'YYYY-MM-DD HH:mm:ss'
): string => {
  return dayjs(date).tz('Asia/Shanghai').format(format);
};

/**
 * 获取当前北京时间
 * @param format 格式化模式，默认为 'YYYY-MM-DD HH:mm:ss'
 * @returns 当前北京时间字符串
 */
export const getCurrentBeijingTime = (format: string = 'YYYY-MM-DD HH:mm:ss'): string => {
  return dayjs().tz('Asia/Shanghai').format(format);
};

/**
 * 获取当前北京时间的dayjs对象
 * @returns 北京时间的dayjs对象
 */
export const getBeijingTimeNow = (): dayjs.Dayjs => {
  return dayjs().tz('Asia/Shanghai');
};

/**
 * 将时间转换为北京时间的dayjs对象
 * @param date 时间字符串或Date对象
 * @returns 北京时间的dayjs对象
 */
export const toBeijingTime = (date: string | Date | dayjs.Dayjs): dayjs.Dayjs => {
  return dayjs(date).tz('Asia/Shanghai');
};

/**
 * 常用时间格式常量
 */
export const TIME_FORMATS = {
  DATETIME: 'YYYY-MM-DD HH:mm:ss',
  DATE: 'YYYY-MM-DD',
  TIME: 'HH:mm:ss',
  MONTH: 'YYYY-MM',
  YEAR: 'YYYY',
  DATETIME_MINUTE: 'YYYY-MM-DD HH:mm',
  FILE_TIMESTAMP: 'YYYYMMDDHHmmss',
  DISPLAY_DATETIME: 'YYYY年MM月DD日 HH:mm:ss',
  DISPLAY_DATE: 'YYYY年MM月DD日'
};

export default {
  formatBeijingTime,
  getCurrentBeijingTime,
  getBeijingTimeNow,
  toBeijingTime,
  TIME_FORMATS
};